import { BankSuggestions } from 'react-dadata';

import { DADATA_TOKEN } from '../../shared';

const taxSystems = {
  sno: {
    osn: 'ОСН',
    usn_income: 'УСН, 6%',
    usn_income_outcome: 'УСН, 15%',
    envd: 'ЕНВД',
    patent: 'Патент',
    esn: 'ЕСН',
  },
  vat: {
    vat20: 'плюс 20% НДС',
    vat10: 'плюс 10% НДС',
    vat5: 'плюс 5% НДС',
    vat7: 'плюс 7% НДС',
    vat120: 'в т.ч НДС 20%',
    vat110: 'в т.ч НДС 10%',
    vat105: 'в т.ч НДС 5%',
    vat107: 'в т.ч НДС 7%',
    vat0: '0%',
    none: '',
  },
};

const changePasswordFields = [
  {
    name: 'oldPassword',
    placeholder: 'Старый пароль',
  },
  {
    name: 'password',
    placeholder: 'Новый пароль',
  },
  {
    name: 'confirmPassword',
    placeholder: 'Повтор пароля',
  },
];

const accountAddModalFields = [
  {
    label: 'Расчетный счет',
    name: 'number',
    placeholder: 'Введите расчетный счет',
  },
  {
    label: 'Банк',
    name: 'bankName',
    token: DADATA_TOKEN,
    component: BankSuggestions,
    inputProps: {
      className: 'ant-input',
      placeholder: 'Введите название банка или БИК',
      name: 'bankName',
    },
    count: 5,
    pathParts: ['value'],
    dependentFields: [
      {
        name: 'bankBic',
        pathParts: ['data', 'bic'],
      },
      {
        name: 'corAccount',
        pathParts: ['data', 'correspondent_account'],
      },
    ],
  },
  {
    name: 'bankBic',
    hidden: true,
  },
  {
    name: 'corAccount',
    hidden: true,
    disabled: true,
  },
];

const sbpSuccessStatuses = {
  1: 'Заявка на подключение принята',
  2: 'СБП подключена',
};

const coefficients = [
  7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1,
];

const genders = [
  {
    value: 'male',
    title: 'Мужской',
  },
  {
    value: 'female',
    title: 'Женский',
  },
];

const personTypes = [
  {
    value: 'BENEFIZIAR',
    title: 'Бенефициар',
  },
  {
    value: 'FOUNDER',
    title: 'Учредитель',
  },
  {
    value: 'BOSS',
    title: 'Директор',
  },
  {
    value: 'Self-employment',
    title: 'Самозанятый',
  },
];

const documentTypes = [
  {
    value: '21',
    title: 'Паспорт гражданина РФ',
  },
  {
    value: '10',
    title: 'Паспорт иностранного гражданина',
  },
];

const persons = ['Person1', 'Person2', 'Person3', 'Person4', 'Person5'];

export {
  taxSystems,
  changePasswordFields,
  accountAddModalFields,
  sbpSuccessStatuses,
  coefficients,
  genders,
  personTypes,
  documentTypes,
  persons,
};
